import React from "react";
import { Route, Switch } from "react-router-dom";
import SpacePageLayout from "./SpacesRouteWrapper";
import { spaceRoutes } from "./routes";

const SpacesRouter = () => {
  return (
    <SpacePageLayout>
      <Switch>
        {spaceRoutes.map((route, index) => (
          <Route key={index} exact={route.exact} path={route.path}>
            <route.component />
          </Route>
        ))}
      </Switch>
    </SpacePageLayout>
  );
};

export default SpacesRouter;
